/*
 * Copyright (c) 2015 - 2023 by KAA Soft. All rights reserved.
 */

import { adminConfig } from "../adminConfig";
import { formValidationInit } from "./formValidation";
import { httpRequest } from "./httpRequest";
import { loadingButton } from "./utils/loadingButton";
import { handleFormData } from "./form";
export function popup(_ref) {
  var popupId = _ref.popupId,
    title = _ref.title,
    text = _ref.text,
    _ref$type = _ref.type,
    type = _ref$type === void 0 ? 'warning' : _ref$type,
    route = _ref.route,
    _ref$confirm = _ref.confirm,
    confirm = _ref$confirm === void 0 ? undefined : _ref$confirm,
    _ref$html = _ref.html,
    html = _ref$html === void 0 ? '' : _ref$html,
    _ref$isForm = _ref.isForm,
    isForm = _ref$isForm === void 0 ? false : _ref$isForm;
  var popupIdString = 'kaa-popup-' + popupId;
  var typeSymbol;
  if (type === 'warning') {
    typeSymbol = '!';
  } else if (type === 'success') {
    typeSymbol = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24" fill="currentColor"><path d="M10 15.172l9.192-9.193 1.415 1.414L10 18l-6.364-6.364 1.414-1.414z"/></svg>';
  } else if (type === 'error') {
    typeSymbol = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24" fill="currentColor"><path d="M12 10.586l4.95-4.95 1.414 1.414-4.95 4.95 4.95 4.95-1.414 1.414-4.95-4.95-4.95 4.95-1.414-1.414 4.95-4.95-4.95-4.95L7.05 5.636z"/></svg>';
  } else if (type === 'info') {
    typeSymbol = 'i';
  } else if (type === 'question') {
    typeSymbol = '?';
  }
  var template = "<div class=\"kaa-popup is-visible\" id=\"" + popupIdString + "\" role=\"dialog\" aria-hidden=\"false\" aria-modal=\"true\" aria-live=\"assertive\">\n\t\t\t<div class=\"kaa-popup-container\">\n\t\t\t<button type=\"button\" class=\"kaa-popup-close\"><i class=\"gi gi-close\"></i></button>\n\t\t\t<div class=\"kaa-popup-icon " + type + "\">\n\t\t\t<div class=\"kaa-popup-icon-content\">" + typeSymbol + "</div>\n\t\t\t</div>\n\t\t\t<div class=\"kaa-popup-title\"></div>\n\t\t\t<div class=\"kaa-popup-text\"></div>\n\t\t\t<div class=\"kaa-popup-content-container\"></div>\n\t\t\t<div class=\"kaa-popup-actions\">\n\t\t\t<button type=\"button\" class=\"kaa-popup-confirm kaa-popup-button " + type + "\">" + i18n.gettext("Confirm") + "</button>\n\t\t\t<button type=\"button\" class=\"kaa-popup-cancel kaa-popup-button\">" + i18n.gettext("Cancel") + "</button>\n\t\t\t</div>\n\t\t\t</div>\n\t\t\t</div>"; //.replace(/(^|\n)\s*/g, '')
  // console.log(template);
  document.body.insertAdjacentHTML('beforeend', template);
  var popup = document.getElementById(popupIdString);
  var popupTitle = popup.querySelector('.kaa-popup-title');
  var popupText = popup.querySelector('.kaa-popup-text');
  var popupContentContainer = popup.querySelector('.kaa-popup-content-container');
  // let popupContainer = popup.querySelector('.kaa-popup-container');
  var confirmBtn = popup.querySelector('.kaa-popup-confirm');
  var cancelBtn = popup.querySelector('.kaa-popup-cancel');
  var closeBtn = popup.querySelector('.kaa-popup-close');
  var formId = 'kaa-popup-form';
  var queryString;
  popupTitle.textContent = title ? title : 'This action cannot be undone.';
  popupText.textContent = text ? text : 'Are you sure you wish to proceed?';

  // loadingPopup();
  function closePopup() {
    var popup = document.getElementById(popupIdString);
    popup.classList.add('is-hidden');
    setTimeout(function () {
      // popup.classList.remove('is-visible', 'is-hidden');
      popup.remove();
    }, 200);
  }
  function loadingPopup() {
    loadingButton.start(confirmBtn);
    cancelBtn.classList.add('d-none');
    closeBtn.classList.add('d-none');
    popup.setAttribute('aria-busy', "true");
    popup.disabled = true;
  }
  var requestConfig = {
    url: route
  };
  if (html) {
    popupContentContainer.insertAdjacentHTML('afterbegin', html);
  }
  if (isForm) {
    formValidationInit('#' + popupIdString);
  }
  confirmBtn.addEventListener('click', function (e) {
    e.preventDefault();
    if (isForm) {
      if (adminConfig.forms[formId].validate()) {
        var form = document.getElementById(formId);
        if (!form) return console.warn(adminConfig.messages.formNotExist);
        var formDataArray = handleFormData(form);
        queryString = new URLSearchParams(formDataArray).toString();
        requestConfig.data = queryString;
      }
    }
    if (typeof confirm === 'function') {
      console.log('test');
      if (!route) {
        confirm();
      } else {
        loadingPopup();
        httpRequest(requestConfig).then(function (response) {
          if (response && response.data) {
            // processRequestResponse(response.data);
            loadingButton.finish(confirmBtn);
            if (!response.data.error) {
              confirm(response);
              closePopup();
            }
          }
        })["catch"](function (error) {
          cancelBtn.classList.remove('d-none');
          closeBtn.classList.remove('d-none');
          loadingButton.finish(confirmBtn);
          console.error(error);
        });
      }
    } else {
      console.warn('Only a function is allowed.');
    }
  });
  popup.addEventListener('click', function (e) {
    if (e.target === popup || e.target === closeBtn || e.target === cancelBtn) {
      e.preventDefault();
      if (!popup.disabled) {
        closePopup();
      }
    }
  });
}